import { defineComponent as _defineComponent } from 'vue';
import Button from 'primevue/button';
import { ref } from 'vue';
import { trans, transChoice } from 'laravel-vue-i18n';
import { useMitt } from '../../../Plugins/mitt';
import { concatPlotsCodes, formatISODate, getEnumKeyByValue, panelTitle, } from '../../../Services/Utils';
import { SoilDepth, SoilType } from '../../../@types/Enums';
import DetailValue from '../../../Components/DetailValue.vue';
import SoilDataService from '../../../Services/SoilDataService';
import Sidebar from 'primevue/sidebar';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Details',
    emits: ['update:visible'],
    setup(__props, { expose }) {
        expose();
        const emitter = useMitt();
        const soilDataService = new SoilDataService();
        const data = ref();
        const title = ref('');
        const visible = ref(false);
        const edit = () => emitter.emit('open-soil-data-form', data.value);
        emitter.on('soil-data-saved', (data) => (data.value = data));
        const openEventName = 'open-soil-data-details';
        emitter.off(openEventName);
        emitter.on(openEventName, async (eventData) => {
            data.value = await soilDataService.getById(eventData.id);
            title.value = panelTitle('SoilDataDetails', ': ' + eventData.code);
            visible.value = true;
        });
        const __returned__ = { emitter, soilDataService, data, title, visible, edit, openEventName, get Button() { return Button; }, get trans() { return trans; }, get transChoice() { return transChoice; }, get concatPlotsCodes() { return concatPlotsCodes; }, get formatISODate() { return formatISODate; }, get getEnumKeyByValue() { return getEnumKeyByValue; }, get SoilDepth() { return SoilDepth; }, get SoilType() { return SoilType; }, DetailValue, get Sidebar() { return Sidebar; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
